import { Table } from "containers/Table";
import { IColum } from "containers/Table/interfaces";
import { Container, Header, HeaderContainerBotoes, TextoHeader } from "./style";
import { StatusItemLoteBloqueio } from "../StatusItemLoteBloqueio";
import { PrimaryButton } from "components/Button/style";
import {
  FaColumns,
  FaDownload,
  FaExclamationCircle,
  FaFileAlt,
  FaLock,
  FaLockOpen,
} from "react-icons/fa";
import { IListarItensBloqueio } from "../../../../interfaces/IListarItensBloqueio";
import { useState } from "react";
import { defaultConfigColunas } from "../../../../constants/defaultConfigColunas";
import { ModalConfigColunas } from "../ModalConfigColunas";
import { converterDataHoraBr } from "_utils/Data";
import { utils, writeFileXLSX } from "xlsx";
import { toastAtencao, toastErro } from "components/Toast";
import { useBloqueioAdministrativo } from "../../../../hooks/useBloqueioAdministrativo";
import { ModalHistoricoVeiculo } from "../ModalHistoricoVeiculo";
import { IconeErro } from "../iconeErro";
import { lerPlanilha } from "../../../../constants/lerPlanilha";
import { IDadosCriarLote } from "../../../../interfaces/IDadosCriarLote";
import { IPlanilhaCriarLote } from "../../../../interfaces/IPlanilhaCriarLote";
import { defaultDadosCriarLote } from "../../../../constants/defaultDadosCriarLote";
import { ModalCriarLote } from "../../../CriarLote/containers/ModalCriarLote";
import { ModalCertezaAcaoSelecionados } from "../ModalCertezaAcaoSelecionados";
import { IOptions } from "components/DropdownSelect";

interface IListarProps {
  dados: IListarItensBloqueio[];
  handleLimitChange: (e: number) => void;
  handlePageChange: (e: number) => void;
  totalRows: number;
  linhasPorPagina: number;
  relatorioItens: () => any;
  dadosCriarLote: IDadosCriarLote;
  setDadosCriarLote: (dados: IDadosCriarLote) => void;
  setDadosPlanilhaCriarLote: (dados: IPlanilhaCriarLote[]) => void;
  setPagina: (pagina: "LOTES" | "DETALHE" | "CRIAR" | "ITENS") => void;
  setRowsSelected: (itens: IListarItensBloqueio[]) => void;
  selectedRows: IListarItensBloqueio[];
  clearRows: boolean;
  handleReverter: () => void;
  setShowModalCertezaAcaoSelecionados: (show: boolean) => void;
  showModalCertezaAcaoSelecionados: boolean;
  setAcaoSelecionada: (acao: "bloquear" | "desbloquear") => void;
  acaoSelecionada: "bloquear" | "desbloquear";
  empresasOptions: IOptions[];
  cnpjsOptions: IOptions[];
  listarCnpjsIntegracaoFrotista: (idEmpresa: number) => void;
}

export function ListarItens({
  dados,
  handleLimitChange,
  handlePageChange,
  totalRows,
  linhasPorPagina,
  relatorioItens,
  dadosCriarLote,
  setDadosCriarLote,
  setDadosPlanilhaCriarLote,
  setPagina,
  setRowsSelected,
  selectedRows,
  clearRows,
  handleReverter,
  setShowModalCertezaAcaoSelecionados,
  showModalCertezaAcaoSelecionados,
  setAcaoSelecionada,
  acaoSelecionada,
  empresasOptions,
  cnpjsOptions,
  listarCnpjsIntegracaoFrotista,
}: IListarProps) {
  const { buscarHistoricoVeiculo, historicoVeiculo, onClickProcesso } =
    useBloqueioAdministrativo();
  const [showModalHistoricoVeiculos, setShowModalHistoricoVeiculos] =
    useState<boolean>(false);
  const [placaSelecionada, setPlacaSelecionada] = useState<string>("");

  const handleAbrirHistorico = async (idVeiculo: number, placa: string) => {
    const { hasErro, data } = await buscarHistoricoVeiculo(idVeiculo);
    if (hasErro) {
      toastErro(
        data?.message ?? "Não foi possível buscar o histórico do veículo",
      );
      return;
    }
    setPlacaSelecionada(placa);
    setShowModalHistoricoVeiculos(true);
  };
  const [configColunas, setConfigColunas] = useState<
    { nome: string; exibir: boolean }[]
  >(() => {
    try {
      const stored = localStorage.getItem("config_listar_bloqueios_adm");
      return stored ? JSON.parse(stored) : defaultConfigColunas;
    } catch {
      return defaultConfigColunas;
    }
  });
  const [showModalColunas, setShowModalColunas] = useState(false);

  function handleSaveConfigColunas(
    novaConfig: { nome: string; exibir: boolean }[],
  ) {
    localStorage.setItem(
      "config_listar_bloqueios_adm",
      JSON.stringify(novaConfig),
    );
    setConfigColunas(novaConfig);
  }
  const columns: IColum<IListarItensBloqueio>[] = [
    {
      name: "ID",
      selector: ({ idItemBloqueioAdministrativo }: IListarItensBloqueio) =>
        idItemBloqueioAdministrativo ?? "-",
      width: "90px",
      omit: true,
    },
    {
      name: <span>ID Processo</span>,
      selector: ({ idProcesso }: IListarItensBloqueio) =>
        idProcesso ? (
          <div
            className="link-primary"
            style={{ cursor: "pointer" }}
            onClick={() => {
              onClickProcesso(idProcesso);
            }}
          >
            {idProcesso}
          </div>
        ) : (
          "-"
        ),
      width: "110px",
      omit: configColunas.some(
        (config) => config.nome === "idProcesso" && !config.exibir,
      ),
    },
    {
      name: "Placa",
      selector: ({ placa }: IListarItensBloqueio) => placa ?? "-",
      width: "90px",
      omit: configColunas.some(
        (config) => config.nome === "placa" && !config.exibir,
      ),
    },
    {
      name: "Chassi",
      selector: ({ chassi }: IListarItensBloqueio) => chassi ?? "-",
      width: "190px",
      omit: configColunas.some(
        (config) => config.nome === "chassi" && !config.exibir,
      ),
    },
    {
      name: "Renavam",
      selector: ({ renavam }: IListarItensBloqueio) => renavam ?? "-",
      width: "130px",
      omit: configColunas.some(
        (config) => config.nome === "renavam" && !config.exibir,
      ),
    },
    {
      name: "UF",
      selector: ({ uf }: IListarItensBloqueio) => uf ?? "-",
      width: "90px",
      omit: configColunas.some(
        (config) => config.nome === "uf" && !config.exibir,
      ),
    },
    {
      name: "Empresa",
      selector: ({ nomeEmpresa }: IListarItensBloqueio) => nomeEmpresa ?? "-",
      omit: configColunas.some(
        (config) => config.nome === "empresa" && !config.exibir,
      ),
    },
    {
      name: "CNPJ",
      selector: ({ cnpj }: IListarItensBloqueio) => cnpj ?? "-",
      width: "180px",
      omit: configColunas.some(
        (config) => config.nome === "cnpj" && !config.exibir,
      ),
    },
    {
      name: <span>Situação</span>,
      selector: ({ situacao, status }: IListarItensBloqueio) =>
        status !== "CONCLUIDO" ? "Indefinido" : (situacao ?? "-"),
      cell: ({ situacao, status }: IListarItensBloqueio) =>
        status !== "CONCLUIDO" ? (
          <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
            <FaExclamationCircle color="#e67e22" size={13} />
            Indefinido
          </span>
        ) : situacao ? (
          <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
            {situacao === "BLOQUEADO" ? (
              <FaLock color="#dc3545" size={13} />
            ) : (
              <FaLockOpen color="#28a745" size={13} />
            )}
            {situacao.charAt(0) + situacao.slice(1).toLowerCase()}
          </span>
        ) : (
          "-"
        ),
      width: "130px",
      omit: configColunas.some(
        (config) => config.nome === "situacao" && !config.exibir,
      ),
    },
    {
      name: "Divisão",
      selector: ({ nomeDivisao }: IListarItensBloqueio) => nomeDivisao ?? "-",
      width: "180px",
      omit: configColunas.some(
        (config) => config.nome === "divisao" && !config.exibir,
      ),
    },
    {
      name: "Centro de Custo",
      selector: ({ nomeCentroCusto }: IListarItensBloqueio) =>
        nomeCentroCusto ?? "-",
      width: "150px",
      omit: configColunas.some(
        (config) => config.nome === "centroCusto" && !config.exibir,
      ),
    },
    {
      name: "Solicitante",
      selector: ({ nomeSolicitante }: IListarItensBloqueio) =>
        nomeSolicitante ?? "-",
      width: "150px",
      omit: configColunas.some(
        (config) => config.nome === "solicitante" && !config.exibir,
      ),
    },
    {
      name: "Usuário responsável",
      selector: ({ nomeUsuarioResponsavel }: IListarItensBloqueio) =>
        nomeUsuarioResponsavel ?? "-",
      width: "180px",
      omit: configColunas.some(
        (config) => config.nome === "usuarioResponsavel" && !config.exibir,
      ),
    },
    {
      name: "Data",
      selector: ({ dataCriacao }: IListarItensBloqueio) =>
        dataCriacao ? converterDataHoraBr(dataCriacao) : "-",
      width: "160px",
      omit: configColunas.some(
        (config) => config.nome === "data" && !config.exibir,
      ),
    },
    {
      name: "Status Solicitação",
      selector: ({ status }: IListarItensBloqueio) => status ?? "-",
      cell: ({
        status,
        observacao,
        dataCriacao,
        acao,
      }: IListarItensBloqueio) =>
        status ? (
          <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
            <StatusItemLoteBloqueio status={status} />
            {status === "ERRO" && observacao && (
              <IconeErro
                observacao={observacao}
                dataSolicitacao={dataCriacao}
                acao={acao}
              />
            )}
          </span>
        ) : (
          "-"
        ),
      width: "180px",
      omit: configColunas.some(
        (config) => config.nome === "statusSolicitacao" && !config.exibir,
      ),
    },
    {
      name: "Ações",
      selector: () => "",
      cell: ({ idVeiculo, placa }: IListarItensBloqueio) => (
        <FaFileAlt
          size={16}
          style={{ cursor: "pointer", color: "#555" }}
          title="Histórico do veículo"
          onClick={() => handleAbrirHistorico(idVeiculo, placa)}
        />
      ),
      width: "80px",
    },
  ];

  const onClickExportar = async () => {
    const { data, hasErro } = await relatorioItens();

    if (hasErro) {
      toastErro(data?.message ?? "Não foi possível gerar o relatório");
      return;
    }

    if (data.limiteExcedido) {
      toastAtencao(
        "Não foi possível realizar a exportação completa devido ao limite de dados",
      );
    }

    const isVisible = (nome: string) =>
      !configColunas.some((config) => config.nome === nome && !config.exibir);

    const col = (
      label: string,
      config: string | null,
      wch: number,
      valor: (item: IListarItensBloqueio) => string | number,
    ) => ({ label, config, wch, valor });

    const colunasRelatorio = [
      col("ID", null, 10, (item) => item?.idItemBloqueioAdministrativo ?? "-"),
      col("ID Processo", "idProcesso", 12, (item) => item?.idProcesso ?? "-"),
      col("Placa", "placa", 10, (item) => item?.placa ?? "-"),
      col("Chassi", "chassi", 20, (item) => item?.chassi ?? "-"),
      col("Renavam", "renavam", 14, (item) => item?.renavam ?? "-"),
      col("UF", "uf", 6, (item) => item?.uf ?? "-"),
      col("Empresa", "empresa", 25, (item) => item?.nomeEmpresa ?? "-"),
      col("CNPJ", "cnpj", 20, (item) => item?.cnpj ?? "-"),
      col("Situação", "situacao", 15, (item) =>
        item?.status !== "CONCLUIDO" ? "INDEFINIDO" : (item?.situacao ?? "-"),
      ),
      col("Divisão", "divisao", 20, (item) => item?.nomeDivisao ?? "-"),
      col(
        "Centro de Custo",
        "centroCusto",
        18,
        (item) => item?.nomeCentroCusto ?? "-",
      ),
      col(
        "Usuário responsável",
        "usuarioResponsavel",
        18,
        (item) => item?.nomeUsuarioResponsavel ?? "-",
      ),
      col(
        "Solicitante",
        "solicitante",
        18,
        (item) => item?.nomeSolicitante ?? "-",
      ),
      col("Data", "data", 12, (item) =>
        item?.dataCriacao
          ? (converterDataHoraBr(item.dataCriacao) ?? "-")
          : "-",
      ),
      col(
        "Status Solicitação",
        "statusSolicitacao",
        18,
        (item) => item?.status ?? "-",
      ),
    ].filter(({ config }) => config === null || isVisible(config));

    const dadosPlanilha = data.itens.map((item: IListarItensBloqueio) => {
      return Object.fromEntries(
        colunasRelatorio.map(({ label, valor }) => [label, valor(item)]),
      );
    });

    const planilha = utils.json_to_sheet(dadosPlanilha);
    planilha["!cols"] = colunasRelatorio.map(({ wch }) => ({ wch }));
    const workBook = utils.book_new();
    utils.book_append_sheet(workBook, planilha, "Lotes");

    const hoje = new Date();
    const dia = String(hoje.getDate()).padStart(2, "0");
    const mes = String(hoje.getMonth() + 1).padStart(2, "0");
    const ano = hoje.getFullYear();
    const nomeArquivo = `Lotes_Bloqueio_Administrativo_${dia}-${mes}-${ano}.xlsx`;
    writeFileXLSX(workBook, nomeArquivo);
  };

  const [showModalCriarLote, setShowModalCriarLote] = useState<boolean>(false);

  const handleBloquearDesbloquear = (acao: "bloquear" | "desbloquear") => {
    if (selectedRows.length) {
      setAcaoSelecionada(acao);
      setShowModalCertezaAcaoSelecionados(true);
      return;
    }
    setDadosCriarLote({ ...defaultDadosCriarLote, tipo: acao });
    setShowModalCriarLote(true);
  };

  const onClickProsseguir = async () => {
    const leituraPlanilha = await lerPlanilha(dadosCriarLote.arquivo);

    if (leituraPlanilha.temErro) {
      toastErro(leituraPlanilha.mensagemErro);
      return;
    }

    setDadosPlanilhaCriarLote(leituraPlanilha.dados);
    setShowModalCriarLote(false);
    setPagina("CRIAR");
  };

  return (
    <Container>
      <ModalConfigColunas
        show={showModalColunas}
        handleClose={() => setShowModalColunas(false)}
        configColunas={configColunas}
        onSave={handleSaveConfigColunas}
      />
      <ModalHistoricoVeiculo
        show={showModalHistoricoVeiculos}
        handleClose={() => setShowModalHistoricoVeiculos(false)}
        historicoVeiculo={historicoVeiculo}
        placa={placaSelecionada}
      />
      <ModalCriarLote
        dadosCriarLote={dadosCriarLote}
        setDadosCriarLote={setDadosCriarLote}
        show={showModalCriarLote}
        handleClose={() => {
          setShowModalCriarLote(false);
          setDadosCriarLote({ ...defaultDadosCriarLote });
        }}
        onClickProsseguir={onClickProsseguir}
        empresasOptions={empresasOptions}
        cnpjsOptions={cnpjsOptions}
        listarCnpjsIntegracaoFrotista={listarCnpjsIntegracaoFrotista}
      />
      <ModalCertezaAcaoSelecionados
        show={showModalCertezaAcaoSelecionados}
        handleClose={() => setShowModalCertezaAcaoSelecionados(false)}
        onConfirm={handleReverter}
        acao={acaoSelecionada}
      />
      <Header>
        <TextoHeader>Solicitações criadas</TextoHeader>
        <HeaderContainerBotoes>
          <PrimaryButton
            buttonWidth="xl"
            buttonWidthTipo="px"
            type="button"
            onClick={onClickExportar}
            outline
            variante="primary"
            style={{ fontSize: 12 }}
          >
            <FaDownload />
            Exportar
          </PrimaryButton>
          <PrimaryButton
            buttonWidth="xl"
            buttonWidthTipo="px"
            type="button"
            onClick={() => setShowModalColunas(true)}
            outline
            variante="primary"
            style={{ fontSize: 12 }}
          >
            <FaColumns />
            Colunas
          </PrimaryButton>
          <PrimaryButton
            buttonWidth="xl"
            buttonWidthTipo="px"
            type="button"
            onClick={() => {
              handleBloquearDesbloquear("desbloquear");
            }}
            outline
            variante="primary"
            style={{ fontSize: 12 }}
            disabled={
              !!selectedRows.length &&
              selectedRows.some(
                (item) =>
                  item.status === "CONCLUIDO" &&
                  item.situacao === "DESBLOQUEADO",
              )
            }
          >
            <FaLockOpen />
            Desbloquear veículos
          </PrimaryButton>
          <PrimaryButton
            buttonWidth="xl"
            buttonWidthTipo="px"
            type="button"
            onClick={() => {
              handleBloquearDesbloquear("bloquear");
            }}
            variante="primary"
            style={{ fontSize: 12 }}
            disabled={
              !!selectedRows.length &&
              selectedRows.some(
                (item) =>
                  item.status === "CONCLUIDO" && item.situacao === "BLOQUEADO",
              )
            }
          >
            <FaLock />
            Bloquear veículos
          </PrimaryButton>
        </HeaderContainerBotoes>
      </Header>
      <hr></hr>
      <Table
        keyField="id"
        totalRows={totalRows}
        pagination={true}
        columns={columns}
        data={dados}
        paginationRowsPerPageOptions={[30, 50, 100, 300]}
        loading={false}
        onChangeRowsPerPage={handleLimitChange}
        onChangePage={handlePageChange}
        noSubHeader
        possuiTooltip={false}
        rowsPerPage={linhasPorPagina}
        headerFixo
        selectableRows
        setRowsSelected={setRowsSelected}
        clearSelectedRows={clearRows}
      />
    </Container>
  );
}
